var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSketchLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.991,
    height: 52,
    viewBox: "0 0 57.991 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sketchapp-icon",
    transform: "translate(-0.683 -3.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19194",
    "data-name": "Path 19194",
    d: "M12.651,1.712,28.993,0,45.335,1.712l12.653,16.83L28.994,52,0,18.542Z",
    transform: "translate(0.683 3.086)",
    fill: "#1a1a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15704",
    "data-name": "Group 15704",
    transform: "translate(0.683 21.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19195",
    "data-name": "Path 19195",
    d: "M11.816,0,29.169,33.456,0,0Z",
    transform: "translate(0 0)",
    fill: "#1a1a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19196",
    "data-name": "Path 19196",
    d: "M11.816,33.456,29.171,0,0,33.456Z",
    transform: "translate(57.991 33.456) rotate(180)",
    fill: "#1a1a1a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19197",
    "data-name": "Path 19197",
    d: "M0,0H34.289L17.144,33.456Z",
    transform: "translate(12.234 21.63)",
    fill: "#404040",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15705",
    "data-name": "Group 15705",
    transform: "translate(12.063 3.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19198",
    "data-name": "Path 19198",
    d: "M17.027,0,.9,1.741,0,18.856Z",
    fill: "#1a1a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19199",
    "data-name": "Path 19199",
    d: "M17.027,18.856.9,17.116,0,0Z",
    transform: "translate(34.63 18.856) rotate(180)",
    fill: "#1a1a1a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15706",
    "data-name": "Group 15706",
    transform: "translate(0.684 4.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19200",
    "data-name": "Path 19200",
    d: "M0,0,12.762,17.033,11.847,0Z",
    transform: "translate(57.991 17.033) rotate(180)",
    fill: "#404040",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19201",
    "data-name": "Path 19201",
    d: "M0,17.033,12.761,0l-.916,17.033Z",
    transform: "translate(0 0)",
    fill: "#404040",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19202",
    "data-name": "Path 19202",
    d: "M17.144,0,0,18.856H34.289Z",
    transform: "translate(12.234 3.086)",
    fill: "#404040",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketchLogo);
export default __webpack_public_path__ + "static/media/sketch-logo.456eee55defa673ca3467cd72233eadd.svg";
export { ForwardRef as ReactComponent };